import React, { useState, useEffect, useRef } from 'react';
import { Bar } from 'react-chartjs-2';
import 'chartjs-adapter-moment';

const Appliances = () => {
  const [data, setData] = useState([]);
  const [csvAppliancesData, setCsvAppliancesData] = useState([]);
  const [dateEnergy, setDateEnergy] = useState([]);
  const [hasPowerRatingElectricityError, setHasPowerRatingElectricityError] =
    useState(false);
  const [hasPowerRatingGasError, setHasPowerRatingGasError] = useState(false);
  const [hasUsageHoursError, setHasUsageHoursError] = useState(false);
  const [powerRatingElectricity, setPowerRatingElectricity] = useState('');
  const [powerRatingGas, setPowerRatingGas] = useState('');
  const [usageHours, setUsageHours] = useState('');
  const [
    totalEnergyConsumptionElectricity,
    setTotalEnergyConsumptionElectricity,
  ] = useState('');
  const [totalEnergyConsumptionGas, setTotalEnergyConsumptionGas] =
    useState('');
  const [usageHoursError, setUsageHoursError] = useState(false);
  const [name, setName] = useState([]);
  const [showError, setShowError] = useState(false);
  const csvRef = useRef(null);
  const [scope, setScope] = useState('');

  useEffect(() => {
    var dayElem = document.getElementById('day');
    var monthElem = document.getElementById('month');
    var yearElem = document.getElementById('year');

    monthElem.addEventListener('click', function () {
      setScope('month');
      monthElem.classList.add('active');
      yearElem.classList.remove('active');
      dayElem.classList.remove('active');
    });

    yearElem.addEventListener('click', function () {
      setScope('year');
      monthElem.classList.remove('active');
      yearElem.classList.add('active');
      dayElem.classList.remove('active');
    });

    dayElem.addEventListener('click', function () {
      setScope('day');
      monthElem.classList.remove('active');
      yearElem.classList.remove('active');
      dayElem.classList.add('active');
    });

    try {
      const getAppliances = async () => {
        const response = await fetch(
          'https://fusionsmart.seifeddineslimene.com/api/energy-consumption',
          {
            method: 'GET',
            headers: {
              'Content-type': 'application/json',
            },
          }
        );
        const data = await response.json();
        setData(data);
      };

      getAppliances();
      const getCSVAppliancesData = async () => {
        const response = await fetch(
          'https://fusionsmart.seifeddineslimene.com/api/getAppliances',
          {
            method: 'GET',
            headers: {
              'Content-type': 'application/json',
            },
          }
        );
        const data = await response.json();
        setCsvAppliancesData(data);
      };

      getCSVAppliancesData();
      getAppliances();
    } catch (error) {
      console.error(error);
    }
  }, []);

  const AppliancesData = async (e) => {
    e.preventDefault();

    if (
      hasPowerRatingElectricityError ||
      hasPowerRatingGasError ||
      hasUsageHoursError
    ) {
      setShowError(true);
    } else {
      try {
        setShowError(false);
        const response = await fetch(
          'https://fusionsmart.seifeddineslimene.com/api/energy-consumption',
          {
            method: 'POST',
            headers: {
              'Content-type': 'application/json',
            },
            body: JSON.stringify({
              dateEnergy,
              name,
              powerRatingElectricity,
              powerRatingGas,
              usageHours,
            }),
          }
        );

        /*  const responseBody = await response.json();

      const newEnergyData = {
        date: new Date(),
        totalEnergyConsumptionElectricity:
           responseBody.totalEnergyConsumptionElectricity,
         totalEnergyConsumptionGas: responseBody.totalEnergyConsumptionGas,
       };
       

      setData([...data, newEnergyData]);
    } catch (error) {
       console.error(error);
    }
  };*/

        setData([
          ...data,
          {
            date: new Date(),
            //totalEnergyConsumptionElectricity,
            //totalEnergyConsumptionGas,
            dateEnergy,
            name,
            powerRatingElectricity,
            powerRatingGas,
            usageHours,
            totalEnergyConsumptionElectricity,
            totalEnergyConsumptionGas,
          },
        ]);
      } catch (error) {
        console.error(error);
      }
    }
  };

  const deleteCsv = async (e) => {
    e.preventDefault();
    try {
      setShowError(false);
      await fetch('https://fusionsmart.seifeddineslimene.com/api/deleteAllCsvAppliancesData', {
        method: 'DELETE',
      });
      setCsvAppliancesData([]);
    } catch (error) {
      console.error(error);
    }
  };
  const CSVSubmit = async (e) => {
    e.preventDefault();
    let upload = await uploadFile();
    if (upload.error === 0) {
      setCsvAppliancesData(upload.appliancesCsvData);
    } else if (upload.error === 1) {
      alert('File uploading failed - ' + upload.message);
    }
  };

  const uploadFile = async () => {
    let return_data;
    try {
      if (csvRef.current.files.length === 0) {
        throw new Error('No file selected');
      } else {
        let data = new FormData();
        data.append('csvFile', csvRef.current.files[0]);
        const response = await fetch(
          'https://fusionsmart.seifeddineslimene.com/api/uploadAppliances',
          {
            method: 'POST',
            body: data,
          }
        );
        if (response.status !== 200) {
          throw new Error('HTTP response code !== 200');
        }
        return_data = await response.json();
        if (return_data.error === 1) throw new Error(return_data.message);
      }
    } catch (error) {
      return_data = { error: 1, message: error.message };
    }
    return return_data;
  };
  const chartData = {
    labels: data.map((entry) => entry.name),
    datasets: [
      {
        label: 'TotalEnergyElectricity',
        data: csvAppliancesData
          ? csvAppliancesData.map((entry) => entry.TotalEnergyElectricity)
          : data.map((entry) => entry.TotalEnergyElectricity),
        backgroundColor: 'rgba(255, 89, 150, 0.6)',
        // borderColor: 'rgba(0, 0, 0, 1)',
      },
      {
        label: 'TotalEnergyGas',
        data: csvAppliancesData
          ? csvAppliancesData.map((entry) => entry.TotalEnergyGas)
          : data.map((entry) => entry.TotalEnergyGas),
        backgroundColor: 'rgba(75, 60, 170, 0.6)',
        //borderColor: 'rgba(0, 255, 0, 0.5)',
      },
    ],
  };


  const options = {
    indexAxis: 'y',
    responsive: true,
    plugins: {
      legend: {
        position: 'bottom',
      },
      title: {
        display: true,
        text: 'Appliances chart',
      },
    },
  };

  const handleChangeData = (e) => {
    if (e.target.name === 'powerRatingElectricity') {
      setShowError(false);
      if (e.target.value.length === 0 || isNaN(parseInt(e.target.value))) {
        setHasPowerRatingElectricityError(true);
        setPowerRatingElectricity(e.target.value);
      } else {
        setHasPowerRatingElectricityError(false);
        setPowerRatingElectricity(e.target.value);
      }
    } else if (e.target.name === 'powerRatingGas') {
      setShowError(false);
      if (e.target.value.length === 0 || isNaN(parseInt(e.target.value))) {
        setHasPowerRatingGasError(true);
        setPowerRatingGas(e.target.value);
      } else {
        setHasPowerRatingGasError(false);
        setPowerRatingGas(e.target.value);
      }
    } else {
      //(e.target.name === 'usageHours'){
      setShowError(false);
      if (e.target.value.length === 0 || isNaN(parseInt(e.target.value))) {
        setUsageHoursError(true);
        setUsageHours(e.target.value);
      } else {
        setHasUsageHoursError(false);
        setUsageHours(e.target.value);
      }
    }
  };

  const resetForm = (e) => {
    e.preventDefault();
    setShowError(false);
    setHasPowerRatingElectricityError(true);
    setHasPowerRatingGasError(true);
    setPowerRatingElectricity('');
    setPowerRatingGas('');
  };

  return (
    <div
      id='content-body'
      className='col-12 col-md-9 col-xl-10 pl-4 pr-4 bd-content'
    >
      <div className='mb-5'>
        <form
          onSubmit={AppliancesData}
          className='mt-5 mb-3 d-flex justify-content-center align-items-center'
        >
          <div className='me-2'>
            <span className='d-inline-block me-2'>Name Appliances</span>
            <input
              type='text'
              value={name}
              name='name'
              onChange={handleChangeData}
              placeholder='Name'
            />
          </div>
          <div className='me-2'>
            <span className='d-inline-block me-2'> dateEnergy</span>
            <input
              type='date'
              value={dateEnergy}
              name='dateEnergy'
              onChange={handleChangeData}
              placeholder='dateEnergy'
            />
          </div>
          <div className='me-2'>
            <span className='d-inline-block me-2'> powerRatingElectricity</span>
            <input
              type='text'
              value={powerRatingElectricity}
              name='powerRatingElectricity'
              onChange={handleChangeData}
              placeholder='power Rating Electricity'
            />
          </div>
          <div className='me-2'>
            <span className='d-inline-block me-2'> powerRatingGas</span>
            <input
              type='text'
              value={powerRatingGas}
              name='powerRatingGas'
              onChange={handleChangeData}
              placeholder='power Rating Gas '
            />
          </div>
          <div className='me-2'>
            <span className='d-inline-block me-2'> usageHours</span>
            <input
              type='text'
              value={usageHours}
              name='usageHours'
              onChange={handleChangeData}
              placeholder='usage Hours '
            />
          </div>
          <div>
            <button type='submit' className='me-2'>
              Envoyer
            </button>
            <button onClick={resetForm}>Vider Les Champs</button>

            {showError && (
              <p className='text-center text-danger fw-bold'>
                *Renseigner tous les champs avant de valider, tous les champs
                doivent être des nombres!
              </p>
            )}
          </div>
        </form>
        <div className='mb-5'>
          <form
            onSubmit={CSVSubmit}
            className='mt-5 mb-3 d-flex justify-content-center align-items-center'
          >
            <div className='me-2'>
              <span className='d-inline-block me-1'>CSV</span>
              <input
                ref={csvRef}
                id='emissions-csv'
                accept='text/csv'
                type='file'
                name='cost-csv'
              />
            </div>
            <button type='submit' className='me-2'>
              Envoyer CSV
            </button>
            <button className='me-2' onClick={deleteCsv}>
              Delete CSV
            </button>
          </form>
        </div>
        <div className='mb-5 text-center'>
          <ul className='buttonwrapper'>
            <li id='day' className='active'>
              <label id='l1'>DAY</label>
            </li>
            <li id='month'>
              <label id='l2'>MONTH</label>
            </li>
            <li id='year'>
              <label id='l3'>YEAR</label>
            </li>
          </ul>
        </div>
        <h1> Appliances Chart</h1>
        <div>
          <div>
            {data.length > 0 && <Bar data={chartData} options={options} />}
          </div>
        </div>
        <div className='row'>
          <div className='col-md-12 pb-3'>
            <span className='footer-text-1'>Energy Tip: </span>
            <span className='footer-text-2'>
              On all days, turning off or unplugging electrical devices when
              you're not at departments can help reduce your energy costs by
              approximately 10 percent.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Appliances;
